// extracted by mini-css-extract-plugin
export default {"popup-bubble":"mapCard_popup-bubble__4Q-ml","popup-bubble-anchor":"mapCard_popup-bubble-anchor__LYQAG","popup-container":"mapCard_popup-container__y5Fj9"};